import { Component, Input, OnChanges, OnInit, SimpleChanges, ElementRef, ViewChild } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { first } from 'rxjs';
import { AutomationService } from 'src/app/services/automation.service';
import { ControlService } from 'src/app/services/control.service';
import { DeviceService } from 'src/app/services/device.service';
import { ChangeDetectorRef } from '@angular/core';
import { ProcessMonitorService } from 'src/app/services/process-monitor-service.service';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DeviceStatusPipe } from 'src/app/device-status-pipe';

@Component({
    selector: 'app-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.css'],
    standalone: true,
    imports: [TranslateModule, CommonModule, FormsModule, DragDropModule, DeviceStatusPipe]
})
export class InfoComponent implements OnInit {
  dragPlaceholder: any;
  @ViewChild('placeholderTemplate') placeholderTemplate: ElementRef;

  @Input() control: ControlService;
  @Input() device: any;
  airplaneMode: boolean

  sdCardMounted: any;
  ROM: any;
  totalMem: any;
  cpuData: any = {};
  usedMemory: any;
  freeMemory: any;
  processes: any;
  Memory: {
    RAM: null
  }
  cpu: { name: null }

  allCards: string[] = ['physical', 'display', 'platform', 'memory', 'battery', 'network', 'hardware', 'cpu'];
  cardVisibility: { [key: string]: boolean } = {
    'physical': true,
    'display': true,
    'platform': true,
    'memory': true,
    'battery': true,
    'network': true,
    'hardware': true,
    'cpu': true
  };

  constructor(
    private automationService: AutomationService, private deviceService: DeviceService, private cdr: ChangeDetectorRef,private processMonitor: ProcessMonitorService  
  ) {
    this.deviceService.socketService.scoped().on('device.change', this.changeListener.bind(this));

  }

  ngOnInit(): void {
    window.onbeforeunload = null;



    if (this.device.airplaneMode == true) {

      this.device.airplaneMode = true

    }
    if (this.device.airplaneMode == false) {
      this.device.airplaneMode = false
    }
    //     setInterval(() => {
    //       }, 5000);



    this.getSdStatus();
    this.initializeCardLayouts();
    // this.getCpuInfoFromTop();
    // this.getMemoryInfo();
    // this.getRomInfo();
    // this.getCpuName();
    // this.getCpuCores();
    //changed on13mar
    // this.getCpuInfo();git
  }

  
  private changeListener(event: any): void {
    if (event.data.airplaneMode == true) {
      this.device.airplaneMode = true


    }
    if (this.device.airplaneMode == false) {
      this.device.airplaneMode = false

    }
    //  this.device.airplaneMode=event.data.airplaneMode


    // const device = this.get(event.data);

  }

  openDevicePhoto(device) {
    let title = device.name;
    let enhancedPhoto800 = '/static/app/devices/photo/x800/' + device.image;
    // LightboxImageService.open(title, enhancedPhoto800)
  }

  getSdStatus() {
    if (this.control) {
      this.control.getSdStatus().then((result) => {
        this.sdCardMounted = (result.lastData === 'sd_mounted');
        // $scope.$apply(function() {
        //   $scope.sdCardMounted = (result.lastData === 'sd_mounted')
        // })
      })
    }
  }

  private initializeCardLayouts() {
    try {
      const savedLayout = localStorage.getItem('infoLayout');
      
      if (savedLayout) {
        const layout = JSON.parse(savedLayout);
        if (layout && layout.leftColumn && Array.isArray(layout.leftColumn)) {
          this.allCards = layout.leftColumn;
        }
      }
      // Make sure all cards are visible by default
      this.allCards.forEach(card => {
        this.cardVisibility[card] = true;
      });
    } catch (e) {
      console.error('Error initializing card layouts', e);
    }
  }


  private saveLayout() {
    try {
      const layout = {
        leftColumn: this.allCards,
      };
      localStorage.setItem('infoLayout', JSON.stringify(layout));
    } catch (e) {
      console.error('Error saving layout', e);
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(this.allCards, event.previousIndex, event.currentIndex);
      this.saveLayout();
      this.cdr.detectChanges(); // Force the view to update
    }
  }

  
  onDragStarted(event: any) {
    if (event && event.source && event.source.element) {
      const element = event.source.element.nativeElement;
      this.dragPlaceholder = {
        width: `${element.offsetWidth}px`,
        height: `${element.offsetHeight}px`,
        cardType: event.source.data
      };
    }
  }

  private getCpuCores() {
    if (!this.control) return;
  
    const command = "grep -c ^processor /proc/cpuinfo";
  
    if (!this.device.cpu) {
      this.device.cpu = { name: '-', cores: '-' }; // Ensure both fields are initialized
    } else if (this.device.cpu.cores === undefined) {
      this.device.cpu.cores = '-';
    }
  
    this.control.shell(command).then((result) => {
      try {
        let coreCount;
  
        if (typeof result === 'string') {
          coreCount = result.trim();
        } else if (result && typeof result.data === 'object') {
          coreCount = result.data[0].trim();
        } else {
          coreCount = '-';
        }
        this.device.cpu.cores = coreCount || '-';  
      } catch (error) {
        console.error('Error processing CPU core data:', error);
        this.device.cpu.cores = '-';
      } finally {
        this.cdr.detectChanges();
      }
    }).catch(error => {
      console.error('Error executing shell command for CPU core count:', error);
      this.device.cpu.cores = '-';
      this.cdr.detectChanges();
    });
  }
  

  private getCpuName() {
    if (!this.control) return;
    
    const command = "getprop ro.soc.manufacturer";
    
    if (!this.device.cpu) {
      this.device.cpu = { name: '-' };
    }
    
    this.control.shell(command).then((result) => {
      try {
        let cpuName;
        
        if (typeof result === 'string') {
          cpuName = result.trim();
        } else if (result && typeof result.data === 'object') {
          cpuName = result.data[0].trim();
        } else {
          cpuName = '-';
        }        
        this.device.cpu.name = cpuName || '-';        
      } catch (error) {
        console.error('Error processing CPU name data:', error);
        this.device.cpu.name = '-';
      } finally {
        this.cdr.detectChanges();
      }
    }).catch(error => {
      console.error('Error executing shell command for CPU name:', error);
      this.device.cpu.name = '-';
      this.cdr.detectChanges();
    });
  }

  private getCpuInfoFromTop() {
  if (!this.control) return;
  
  this.control.shell('top').then((data: any) => {
    try {
      // Parse the system data
      const parsed = this.processMonitor.parseSystemData(data.data);
      
      // Set direct values for all fields as type 'any', same as totalMem
      this.totalMem = parsed.memoryUsagePercent + ' %';
      
      // Set cpuData directly 
      this.cpuData = {
        name: 'CPU',
        cores: parsed.totalCpuCores,
        used: parsed.cpuUsage?.[0]?.userPercent + parsed.cpuUsage?.[0]?.sysPercent || 0,
        free: parsed.cpuUsage?.[0]?.idlePercent || 100
      };
      
      // Preserve original memory values but add formatted versions
      // Keep the original unformatted values
      const originalTotalMem = parsed.totalMemory;
      const originalUsedMem = parsed.usedMemory;
      const originalFreeMem = parsed.freeMemory;
      
      // Add formatted versions only if the originals contain actual data
      if (originalTotalMem && originalTotalMem !== '0') {
        // Check if the value already has a unit (KB, MB, GB, etc)
        if (typeof originalTotalMem === 'string' && 
            (originalTotalMem.includes('KB') || 
             originalTotalMem.includes('MB') || 
             originalTotalMem.includes('GB'))) {
          // Already formatted, keep as is
          this.totalMem = originalTotalMem;
        } else {
          // Try to extract numeric value if it's a string with units
          const numericValue = this.extractNumericValue(originalTotalMem);
          this.totalMem = this.formatSize(numericValue);
        }
      } else {
        this.totalMem = originalTotalMem || '0 B';
      }
      
      if (originalUsedMem && originalUsedMem !== '0') {
        if (typeof originalUsedMem === 'string' && 
            (originalUsedMem.includes('KB') || 
             originalUsedMem.includes('MB') || 
             originalUsedMem.includes('GB'))) {
          this.usedMemory = originalUsedMem;
        } else {
          const numericValue = this.extractNumericValue(originalUsedMem);
          this.usedMemory = this.formatSize(numericValue);
        }
      } else {
        this.usedMemory = originalUsedMem || '0 B';
      }
      
      if (originalFreeMem && originalFreeMem !== '0') {
        if (typeof originalFreeMem === 'string' && 
            (originalFreeMem.includes('KB') || 
             originalFreeMem.includes('MB') || 
             originalFreeMem.includes('GB'))) {
          this.freeMemory = originalFreeMem;
        } else {
          const numericValue = this.extractNumericValue(originalFreeMem);
          this.freeMemory = this.formatSize(numericValue);
        }
      } else {
        this.freeMemory = originalFreeMem || '0 B';
      }
      
      this.processes = parsed.processes;      
    } catch (error) {
      console.error('Error processing top data:', error);
    }
  }).catch(error => {
    console.error('Error executing shell command:', error);
  });
}

  private getMemoryInfo() {
    if (!this.control) return;
    
    // Use the specified command for getting total RAM
    const command = "total=$(grep MemTotal /proc/meminfo | tr -dc '0-9'); echo $((total / 1024)) MB";
    
    this.control.shell(command).then((data: any) => {
      try {
        // Get the total RAM from the command result
        const totalRam = data.data[0];      
        this.device.Memory = {
          RAM: totalRam
        };
        
        // Get ROM data if needed
        this.getRomInfo();
        
      } catch (error) {
        console.error('Error processing RAM data:', error);
      }
    }).catch(error => {
      console.error('Error executing shell command for memory:', error);
    });
  }

  // Helper function to extract numeric value from various formats
  private extractNumericValue(value: any): number {
    if (value === undefined || value === null) return 0;
    
    // If it's already a number, return it
    if (typeof value === 'number') return value;
    
    // If it's a string
    if (typeof value === 'string') {
      // Check if it contains units
      if (value.includes('KB')) {
        // Extract number and convert KB to bytes
        const num = parseFloat(value.replace(/[^0-9.]/g, ''));
        return isNaN(num) ? 0 : num * 1024;
      } else if (value.includes('MB')) {
        // Extract number and convert MB to bytes
        const num = parseFloat(value.replace(/[^0-9.]/g, ''));
        return isNaN(num) ? 0 : num * 1024 * 1024;
      } else if (value.includes('GB')) {
        // Extract number and convert GB to bytes
        const num = parseFloat(value.replace(/[^0-9.]/g, ''));
        return isNaN(num) ? 0 : num * 1024 * 1024 * 1024;
      } else {
        // Try to parse as a plain number
        const num = parseFloat(value.replace(/[^0-9.]/g, ''));
        return isNaN(num) ? 0 : num;
      }
    }
    
    // Fallback
    return 0;
  }
  
  private getRomInfo() {
    if (!this.control) return;    
    this.control.shell('df /data | grep /data').then((data: any) => {      
      try {
        // Check if data exists and what its structure is        
        // The issue is likely here - data.data might not be a string
        // Let's handle different possible formats
        let dataStr: string;
        
        if (typeof data === 'string') {
          // If data itself is a string
          dataStr = data;
        } else if (data && typeof data.data === 'string') {
          // If data.data is a string
          dataStr = data.data;
        } else if (data && data.data && data.data.stdout && typeof data.data.stdout === 'string') {
          // If data has nested structure like {data: {stdout: "..."}}
          dataStr = data.data.stdout;
        } else if (data && data.stdout && typeof data.stdout === 'string') {
          // If data has structure like {stdout: "..."}
          dataStr = data.stdout;
        } else {
          // Fallback - convert whatever we got to string
          dataStr = String(data?.data || data || '');
        }
        
        // Now let's trim the string and process it
        const lines = dataStr.trim().split('\n');        
        if (lines.length > 0) {
          const line = lines[0].trim();
          const parts = line.split(/\s+/);          
          // Based on your output format:
          // /dev/block/tmemory-0 236877792 22687848 213721576 10% /data/user/0
          // parts[0] = device, parts[1] = total, parts[2] = used, parts[3] = available, parts[4] = percentage, parts[5] = mount point
          
          if (parts.length >= 6) {
            const totalBlocks = parseInt(parts[1], 10);
            const usedBlocks = parseInt(parts[2], 10);
            const availBlocks = parseInt(parts[3], 10);
            const usedPercent = parts[4];
            
            // Format the values
            const total = this.formatSize(totalBlocks * 1024); // Convert KB to bytes
            const used = this.formatSize(usedBlocks * 1024);
            const avail = this.formatSize(availBlocks * 1024);
            this.ROM = `${total} (${used} used, ${avail} available, ${usedPercent} used)`;
          } else {
            this.ROM = 'Format error: Unexpected output format';
          }
        } else {
          this.ROM = 'No data available';
        }        
      } catch (error) {
        console.error('Error processing df data for ROM:', error, error.stack);
        this.ROM = 'Error: ' + (error.message || 'Unknown error');
      }
    }).catch(error => {
      console.error('Error executing shell command for ROM:', error, error.stack);
      this.ROM = 'Command error: ' + (error.message || 'Unknown error');
    });
  }
  
  private formatSize(bytes: number): string {
    if (isNaN(bytes) || bytes === 0) {
      return '0 B';
    }
    
    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    
    // Return formatted size with 2 decimal places
    return parseFloat((bytes / Math.pow(1024, i)).toFixed(2)) + ' ' + units[i];
  }

  //changed on13mar
  // getCpuInfo(){
  //   this.automationService.getCpuInfo(this.device.serial).pipe(first()).subscribe((data :any) => {
  //     if(data.success == true || data.success == "true"){
  //       this.ROM = data.Info[1].split(' ')[17].trim();
  //       this.totalMem = data.Info[0].split(':')[1].trim();
  //     }
  //   });
  // }

}
